module.exports = __webpack_public_path__ + "static/media/T-C_ExpertMFD.b06b2da4.pdf";